import { Injectable } from '@angular/core';
import { User } from 'app/core/user/user.types';


import { CookieService } from 'ngx-cookie-service';
import { Observable, of } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class UserService {


    constructor(private cookieService: CookieService) {
    }
    /**
    * Update the user
    *
    * @param user
    */
    set user(_user: User) {
        this.cookieService.set('user', encodeURI(JSON.stringify(_user)), { expires: 7, secure: true, sameSite: 'Strict', path: '/' });
    }
    setDataUser(_user: User): Observable<User> {
        this.cookieService.set('user', encodeURI(JSON.stringify(_user)), { expires: 7, secure: true, sameSite: 'Strict', path: '/' });
        return of(_user);
    }

    clearDataUser(): Observable<any> {
        this.cookieService.delete('user', '/', null, true, 'Strict');
        this.cookieService.delete('accessToken', '/', null, true, 'Strict');
        this.cookieService.delete('refreshToken', '/', null, true, 'Strict');
        return of(true);
    }


    /**
    * get the user
    *
    * @param user
    */

    // eslint-disable-next-line @typescript-eslint/member-ordering
    get user$(): User {
        if (this.cookieService.get('user')) {
            return JSON.parse(decodeURI(this.cookieService.get('user'))) as User;
        }

    }

    getDataUser(): Observable<User> {
        if (this.cookieService.get('user')) {
            const user = JSON.parse(decodeURI(this.cookieService.get('user'))) as User;
            return of(user);
        }
        else{
            return of(null);
        }

    }

}
